import { useState, useContext, useEffect } from "react";
import axios from "axios";
import Alert from "../Alert";
import { alertContext } from "../contexts/AlertProvider";
import PermissionGate from "../layout/PermissionGate";

const OrdableApiKey = () => {
  const [data, setData] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [_, setAlertConfig] = useContext(alertContext);
  const token = localStorage.getItem("token");

  const fetchSetting = async () => {
    setIsLoading(true);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_ENDPOINT}settings/get?key=ordable-api-key`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      if (res.data.code === 1) {
        const value = res?.data?.data?.value ?? "";
        setData(value);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  const updateSetting = async () => {
    if (!data?.trim()) {
      setError("Please enter api key");
      return;
    }

    setError("");
    setIsUpdating(true);

    try {
      const res = await axios.patch(
        `${process.env.REACT_APP_API_ENDPOINT}settings/patch?key=ordable-api-key`,
        { key: "ordable-api-key", value: data },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      setAlertConfig({
        show: true,
        message: res.data.message,
        type: res.data.code === 1 ? "success" : "danger",
      });
    } catch (err) {
      console.error(err);
      setAlertConfig({
        show: true,
        message: "Something went wrong",
        type: "danger",
      });
    } finally {
      setIsUpdating(false);
    }
  };

  useEffect(() => {
    fetchSetting();
  }, []);

  return (
    <form autoComplete="off" id="updateOrdableApiKeyForm">
      <Alert />
      {/* Start:API Key */}
      <div className="row g-5 g-lg-10 mb-5">
        {/*begin::Card*/}
        <PermissionGate required={`view_ordable_api_key`}>
          <div className="card">
            {/*begin::Card body*/}
            <div className="card-body py-4">
              <div className="row">
                <div className="col-md-12 my-3 fv-row">
                  <label className="form-label required">API Key</label>
                  <input
                    type="text"
                    className="form-control add-driver-field"
                    placeholder="Enter api key"
                    value={data}
                    disabled={isLoading || isUpdating}
                    onChange={(e) => {
                      setData(e.target.value);
                      setError("");
                    }}
                  />
                  <small className="text-danger mt-2">{error}</small>
                </div>
              </div>
            </div>
            {/*end::Card body*/}
            <PermissionGate required={`edit_ordable_api_key`} fallback={<></>}>
              <div className="card-footer">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={updateSetting}
                  disabled={isLoading || isUpdating}
                  style={{ minWidth: "160px" }}
                >
                  {isLoading || isUpdating ? (
                    <>
                      Please wait...
                      <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                    </>
                  ) : (
                    "Update"
                  )}
                </button>
              </div>
            </PermissionGate>
          </div>
        </PermissionGate>
        {/*end::Card*/}
      </div>
      {/* End:API Key */}
    </form>
  );
};

export default OrdableApiKey;
